import Vue from 'vue';
import Component from 'vue-class-component';

import ProductSectionComponent from '@/components/index-viewport-components/ProductSectionComponent.vue';
import ProductAlphabeticalComponent from '@/components/index-viewport-components/ProductAlphabeticalComponent.vue';
import { Viewport, IndexViewport, ProductViewport } from '@/models/Viewport';
import { ViewportScrollInformations,ViewPortModus, Language, ProductSection, SpaceProperty } from '@/models/ProductModels';
import { populateProductSpace } from '@/models/UtilService';
import SoftbookVersionSelectDropdown from '@/components/product-viewport-components/SoftbookVersionSelectDropdown.vue';
//import {productStruct} from '@/softbooks/StaticDatas';
import {productStructureDe, spaceKeys,productStructureEn} from '@/softbooks/ManualsSoftbook';


@Component({
   
    components:{
        'product-section': ProductSectionComponent,
        'product-alphabetical': ProductAlphabeticalComponent,
        'version-select': SoftbookVersionSelectDropdown

    }
})
export default class SoftbookServicePackPage extends Vue{

    public productViewport:Viewport= null;
    public prodStruct:any = {};
    public homeHREF:string = 'HomeReference';
    public spKeys = JSON.parse(spaceKeys);
    public currentKey = '';
    public currentSpaceInfos = {};
    public productStruct = {};
    public currentUpdatedManualListe:any = [];
    public currentUpdatedReleaseNoticesListe:any = [];
    public currentSpaceProps:any = {};
    public mainReleaseNotice:any= null;
 

    viewportScrollInformations:ViewportScrollInformations = 
{
    language: Language.DE,
    themeUrl:'theme-url',
    spaceKey:'spaceKey',
    prodName:'EDT',
    contextPath:'Context-Path',  
    spaceName:'Space-Name', 
    isIndex: false,
    isSearch:false,
    searchType:'noneed',
    searchTerm:'Search-Termatik'
}




    constructor(){
        super();
      /*  this.productViewport = new ProductViewport(this.spaceProperty,this.viewportScrollInformations);
        this.productViewport.viewportModus = ViewPortModus.PRODUCT_SECTION;
        this.productViewport.viewportEvironment='softbook';
        */
    }

  
    beforeRouteUpdate (to, from, next) {
       // console.log('BEFORE ROUTE UPDATE CALLED');

        this.currentKey = this.$route.params.id;
        next();
        //console.log('BEFORE ROUTE UPDATE CALLED');
      }


    getFileLink(direct_link:string){
return 'manuals/'+direct_link;
    }

    getIconCass(mediatype){
        let iconClass:string="fa-file-pdf-o";

       // console.log("NOW GETTING THE MEDIA TYPE: ",mediatype);
        switch (mediatype) {
            case "fa-mediatype-text":
                iconClass = "fa-file-text-o";
                break;
            case "fj-mediatype-iso":
                    iconClass = "fa-file-iso-o";
                    break;
            case "fj-mediatype-pdf":
                iconClass = "fa-file-pdf-o"
                break;
            case "fj-mediatype-zip":
                iconClass = "fa-file-zip-o"
                break;
            default:
                break;
        }
        return iconClass;
    }
    routerLink(){
     //   return `${this.$i18n.locale}/product/${this.prod.latestVersion.spaceKey}`;
    }

    routerLinkForSoftbook(servPackentry:any){
        return `${this.$i18n.locale}/product/${servPackentry.spaceKey}`;
    }
    created(){
        //console.log('Softbook ServicePack Page Created');
        this.currentKey = this.$route.params.id;
        let currKey = this.currentKey;
        this.currentSpaceInfos = this.spKeys[this.currentKey];
        this.currentSpaceProps =  this.currentSpaceInfos['spaceProperties'];
        this.mainReleaseNotice = this.currentSpaceInfos['releaseNotice'];


        //console.log('Here are the spaceProps for this service Pack '+this.currentKey, this.currentSpaceProps)
        //console.dir(this.currentSpaceInfos);

        this.prodStruct = this.currentSpaceProps['lang']==0?
        JSON.parse(productStructureDe):JSON.parse(productStructureEn);
        
        //first find the needed service Pack (need to be refactor for direct access)
        let allServicePack =  this.prodStruct['servicePacks'];
        let currentServicePack:any=null;
        
        for (let pack of allServicePack){
            if(pack.spaceKey === this.currentKey){
                currentServicePack = pack;
            }
        }
 
        if(!currentServicePack){
            throw new Error ('Requested Service Pack not found. Please check it again ');
        }

        this.currentUpdatedManualListe = currentServicePack.updatedProducts;
        this.currentUpdatedReleaseNoticesListe = currentServicePack.updatedReleaseNotices;

        this.viewportScrollInformations.spaceKey = this.currentKey;
        this.viewportScrollInformations.prodName =this.currentSpaceProps.servicePackName;

        this.productViewport =  new ProductViewport(this.currentSpaceInfos['spaceProperties'], this.viewportScrollInformations);
        

        
        this.productViewport.utilserv.productStructur = this.prodStruct;
       
       return populateProductSpace(<ProductViewport>this.productViewport);

    }


}
